import React, { useRef, useState } from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";
import UIModal from "../../../Domain/Components/UI/Modal/Modal";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { toast } from "react-toastify";
import { postApiCall, postFileApiCall } from "../../../Infrastructure/Helpers/HttpHandler";

function GameConfigListPage(props) {
    const fileInputRef = useRef(null);
    const [uploadUrl, setUploadUrl] = useState(null);

    const bulkInsertGameConfigs = () => {
    setUploadUrl('import-csv/game-config');
    fileInputRef.current?.click();
};

    const bulkInsertOperatorGameConfigs = () => {
        setUploadUrl('import-csv/operator-game-config');
        fileInputRef.current?.click();
    };

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();

        formData.append("file", file); 

        try {
          const token = getWithExpiry("token");
          if (!token) {
            props.setLoggedIn(false);
            return;
          }
      
          const response = await postFileApiCall(uploadUrl, formData, token);
      
            if (response.ok) {
                toast.success("Game Configs imported successfully! Please reload Page.");
            } else {
                toast.error(response.data?.error?.message || "Error uploading fileeee");
            }
      
        } catch (err) {
          console.error(err);
          toast.error("Error uploading file");
        }
    }

    return(
        <>
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileUpload}
            />
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            deleteModalTitile={"Delete Game Config"}
                            deleteModalQuestion={"Are you sure you want to delete this game config?"}
                            editHref={"/game-config/update"}
                            detailsHref={"/game-config/details"}
                            objectKeys={["id", "name", "provider.name", "provider.parent_provider.name"]}
                            columnTitles={[
                                "ID", "Name", "Provider", "Agregator"
                            ]}
                            insertHref={"/game-config/create"}
                            insertTitle={"Add Game Config"}
                            pageTitle={"Game Configs"}
                            deleteEndpoint={"game-config/delete"}
                            readEndpoint={"game-config/read"}
                            relations={["provider", "provider.parent_provider"]}
                            buttonData={[
                                {
                                    title: "Bulk insert",
                                    onClick: bulkInsertGameConfigs
                                },
                                {
                                    title: "Bulk map",
                                    onClick: bulkInsertOperatorGameConfigs
                                }
                            ]}
                            />
        </>
    )
}

export default GameConfigListPage;